import { createSlice } from '@reduxjs/toolkit';
import { getBannerlist} from './bannerAction';

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const bannerSlice = createSlice({
    name: 'banner',
    initialState,
    reducers: {
        resetError(state) {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(getBannerlist.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBannerlist.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getBannerlist.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })  
    },
});

export const { resetError } = bannerSlice.actions;

export default bannerSlice.reducer;
